import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileNumberDisplay'
})
export class MobileNumberDisplayPipe implements PipeTransform {

  transform(value: string, args?: string): any {
    if (args === undefined) {
      return value;
    }

    if (value.indexOf(args) < 0) {
      return value;
    }

    const formattedValue = value.substring(value.indexOf(args)+args.length);
    return formattedValue;
  }

}
